export enum PhotoRating {
    Unknown = "",
    General = "G",
    Restricted = "R",
    Explicit = "X",
}
